import React from 'react'
import {  Accordion } from 'react-bootstrap'
import { ettermek } from "../Database";
import Item from "../Item";
import Pageheader from '../partials/Pageheader';

function Ettermek() {
	return (
		<>
			<Pageheader>Éttermek</Pageheader>
			<Accordion flush>
				{ettermek.map((item, index) =>
					<Item img={item.img} face={item.face} title={item.title} id={index} key={index}>{item.text}</Item>
				)}
			</Accordion>
		</>
	)
}

export default Ettermek